import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SuperAdminApiTokensContextType {
  isOpen: boolean;
  selectedBrandId: string | null;
  openApiTokensDialog: (brandId: string) => void;
  closeApiTokensDialog: () => void;
}

const SuperAdminApiTokensContext = createContext<SuperAdminApiTokensContextType | undefined>(undefined);

export const useSuperAdminApiTokens = () => {
  const context = useContext(SuperAdminApiTokensContext);
  if (!context) {
    throw new Error('useSuperAdminApiTokens must be used within a SuperAdminApiTokensProvider');
  }
  return context;
};

interface SuperAdminApiTokensProviderProps {
  children: ReactNode;
}

export const SuperAdminApiTokensProvider: React.FC<SuperAdminApiTokensProviderProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedBrandId, setSelectedBrandId] = useState<string | null>(null);

  const openApiTokensDialog = (brandId: string) => {
    setSelectedBrandId(brandId);
    setIsOpen(true);
  };

  const closeApiTokensDialog = () => {
    setIsOpen(false);
    setSelectedBrandId(null);
  };

  return (
    <SuperAdminApiTokensContext.Provider value={{ isOpen, selectedBrandId, openApiTokensDialog, closeApiTokensDialog }}>
      {children}
    </SuperAdminApiTokensContext.Provider>
  );
};
